import projects from './APIProjectRepository'
import conversations from './APIConversationRepository'
import PushNotificationRepository from './PushNotificationRepository'

export default {      
    computed: {
      name () {
        return this.$route.name
      },
      list () {
        return this.$route.matched.filter((route) => route.name || route.meta.label )
      },         
    },    
    mounted(){      

      this.$root.$on('setToggleUserDetails', function(){           
        this.setToggle()
      }.bind(this))

      this.$root.$on('changeMessageRoute', function(projectid,conversationid){           
        this.changeMessageRoute(projectid,conversationid)
      }.bind(this))    
      
      this.$root.$on('deviceRegistrationStatus', function(permission){         
        if (permission=="granted") this.userIsSubscribed = true            
      }.bind(this))       

      this.loadProjectList()   

    },
    created(){                    
      PushNotificationRepository.init(this.$root).then((res)=>{                           
        this.userIsSubscribed =  res        
        console.log(res)
      })

    },
    methods: {
      setToggle: function() {              
        this.$refs.fileInput.toggle()
      },
      loadProjectList(){
                
        projects.getProjects(this.$route.params.projectid).then((res)=>{

          if(typeof(res.response)=="undefined")return        
        
          this.projectsList = res.response.data   
          
          let projectHashArray=[]
          this.projectsList.forEach(function(x) {             
            projectHashArray.push(x.web_push_token)
          })
                                      
          //PushNotificationRepository.setProjectTag(projectHashArray)
                  
          if (this.isCurrentUrlMessagePage()){     
            this.currentProjectID = JSON.parse(localStorage.getItem('lastProjectSelected')).id
                        
            if (this.$route.params.conversationid){              
              conversations.getConversation(this.$route.params.conversationid).then((res)=>{                       
                let type='bot'
                if (res.status==200){
                  if (res.response.data.manual) type='mine'
                  this.$root.$emit("loadConversationList",type,this.currentProjectID,this.$route.params.conversationid)                  
                }else{
                  this.$root.$emit("loadConversationList",type,this.currentProjectID)
                } 
                this.$root.$emit("changeMessageRoute", this.currentProjectID) 
              })
            }else{
              this.$root.$emit("loadConversationList",'bot',this.currentProjectID)
              this.$root.$emit("changeMessageRoute", this.currentProjectID)
            }                
            
          }          

        })  
      },
      onChangeProject() {     
                                    
          var projectid = document.getElementById("projectSwitcher").value
          var name = document.getElementById("projectSwitcher").options[document.getElementById("projectSwitcher").options.selectedIndex].text

          projects.setCurrentProject({"id":projectid,"name":name, "selected":true}) 
          this.changeMessageRoute(projectid,null,true)                                                     

      },
      changeSideMenuLink(projectID=this.currentProjectID,conversationid=null){

          if (projectID==null) return false
          let mid = ''
          if (conversationid!=null) mid = "/" + conversationid

          let menuItemMessages = this.navItems.findIndex(x => x.name == "Conversazioni")                
          this.navItems[menuItemMessages].url = '/messages/' + projectID  + mid    

      },
      changeMessageRoute(projectID=this.currentProjectID,conversationid=null,reloadConversationList=false){
                
          if (projectID==null) return false
          let mid = ''
          if (conversationid!=null) mid = "/" + conversationid

          this.$router.push({path: '/messages/' + projectID + mid}, () => {     
              
              this.changeSideMenuLink(projectID,conversationid)
              if (reloadConversationList) this.$root.$emit("loadConversationList",'bot',projectID)                

          })            

      },
      isCurrentUrlMessagePage(){
          return (this.$router.currentRoute.path.indexOf("/messages/") >-1)
      }      
            
    }
}